import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from '../../../../components/angle/Panel/index';
import Select from '../../../../components/Select/index';
import { formInputValidation } from '../../../../services/helper/form-helper';

class SearchTerminatedFilingsPanel extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            clientId: ''
        };
    }
    componentDidMount() {
        let { user } = this.props;
        if (user && user.roleName === 'User') {
            this.setState({
                clientId: user.clientId
            });
        }
    }

    handleSelectChange = (type, value) => {
        this.props.onClientChange({
            [type]: value ? value.clientId : ''
        });
    };

    onSearch = () => {
        let { onSearchClick } = this.props;
        if (formInputValidation(this.formRef.current)) {
            onSearchClick();
        }
    };
    render() {
        let { clientList, user, clientSelected } = this.props;
        let viewButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSearch}
            >
                Show
            </button>
        );
        const buttonList = [viewButton];
        return (
            <Panel
                showFooter
                footerComponents={buttonList}
                panelStyle="panel-default m0"
            >
                <form ref={this.formRef}>
                    <div className="row">
                        <div className="col-md-6 mb">
                            <Select
                                id="terminatedFilingsClientId"
                                name="terminatedFilingsClientId"
                                placeholder="Choose a Client"
                                labelKey="name"
                                valueKey="clientId"
                                selectedValue={clientSelected}
                                onChange={this.handleSelectChange}
                                options={clientList}
                                required={true}
                                disabled={
                                    user && user.roleName !== 'Administrator'
                                }
                            />
                        </div>
                    </div>
                </form>
            </Panel>
        );
    }
}

SearchTerminatedFilingsPanel.propTypes = {
    onSearchClick: PropTypes.func.isRequired
};

export default SearchTerminatedFilingsPanel;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SearchFilings/SearchTerminatedFilingsPanel.js